interface SetCookieParams {
  key: string;
  value: any;
  path?: string;
  days?: number;
}

export const getCookie = (key: string) => {
  if (!key) return;
  return decodeURIComponent(
    document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${key}=`))
      ?.split("=")?.[1] || "",
  );
};

export const setCookie = ({ key, value, path, days = 99999 }: SetCookieParams) => {
  const expire = new Date();
  expire.setDate(expire.getDate() + days);
  document.cookie = `${key}=${encodeURIComponent(value)}; expires=${expire.toUTCString()};${path ? `path=${path};` : ""}`;
  return true;
};

export const deleteCookie = ({ key, path = "/" }: { key: string; path?: string }) => {
  if (!getCookie(key)) return;
  setCookie({ key, value: "", path, days: -1 });
};
